import React from 'react';
import { Col } from 'reactstrap';
import { AdditionalLabelledMultiSelect } from '..';
import { AnalyticsFiltersService } from '../../../../../services/v1/candidate_experience/Analytics';
import { MultiSelectAsyncFilter } from '../../../../MultiSelectAsyncFilter';
import { mapResultToSelectOption } from '../../../../../utils/mapResultToSelectOption';

export function SurveyTracksLabelledMultiSelectCol(props: {
  additionalLabelledMultiSelect: AdditionalLabelledMultiSelect;
}) {
  return (
    <Col xs='12' md='4' xl='2' className='mt-2'>
      <MultiSelectAsyncFilter
        isMulti
        loadOptions={(name, page) =>
          mapResultToSelectOption(
            AnalyticsFiltersService.surveyTemplates({ name, page }),
            (filter) => filter.surveyTemplates,
          )
        }
        label='Survey Tracks'
        onChange={props.additionalLabelledMultiSelect.handleFilterUpdate(
          'surveyTemplates',
        )}
        selected={props.additionalLabelledMultiSelect.selected}
      />
    </Col>
  );
}
